import ActionButton from 'components/ActionButton';
import AddInventoryItemBlogModal from 'components/AddInventoryItemBogModal';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import EditActionForTable from 'components/EditActionForTableData';
import ImageWrapper from 'components/ImageWrapper/index';
import { tableStyles } from 'css/tableStyles';
import React, { useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { removeInventoryItemBlog } from 'services';
import { USER_ROLES, isUserAuthorized, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const ItemBlogs = props => {
  const [addBlogModalOpen, setAddBlogModalOpen] = useState<boolean>(false);
  const {
    blogs,
    itemId,
    onSuccess,
    userRoles,
  } = props;
  const isUserAuthorizedToEdit = isUserAuthorized(userRoles, [USER_ROLES.PACKER, USER_ROLES.SUPERVISOR, USER_ROLES.MANAGER, USER_ROLES.ADMIN]);

  const deleteBlogFn = async (link: string) => {
    try {
      const response = await removeInventoryItemBlog({
        id: itemId,
        link,
      });
      onSuccess(response.toJSON());
      showSuccess('Blog deleted successfully');
    } catch (e) {
      showError(e);
    }
  };
  
  const columns = useMemo(() => [
    {
      name: 'Title',
      selector: 'title',
      width: '400px',
    },
    {
      name: 'Link',
      selector: 'link',
    },
    {
      name: 'Image',
      cell: (row) => {
        const imageUrl = row?.image?._url || row?.image?.url;
        if(!imageUrl){
          return null;
        }
        return(
          <ImageWrapper src={imageUrl} className={`${styles['blog-image']}`} />
        );
      },
    },
    {
      name: 'Action',
      selector: '',
      sortable: false,
      width: '100px',
      omit: !isUserAuthorizedToEdit,
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className='d-flex flex-row'>
          <div className={'ml-3'}>
            <DeleteActionForTable
              onClick={() => deleteBlogFn(row.link)}
            />
          </div>
        </div>
      ),
    },
  ], [blogs]);
  
  const toggleModal = () => setAddBlogModalOpen(!addBlogModalOpen);
  
  return (
    <div className={styles['blogs-container']}>
      {addBlogModalOpen && (
        <AddInventoryItemBlogModal
          itemId={itemId}
          toggleModal={toggleModal}
          onSuccess={onSuccess}
        />
      )}
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Blogs</div>
        {isUserAuthorizedToEdit && <ActionButton
          active={true}
          isLoading={false}
          onClick={toggleModal}
          text={<>Blog <span className={'ml-3'}>+</span></>}
        />}
      </div>
      <DataTable
        noHeader
        data={blogs}
        columns={columns}
        customStyles={tableStyles}
      />
    </div>
  );
};
 
export default ItemBlogs;